import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';

import FacebookLogin from './FacebookLogin';
import GoogleLogin from './GoogleLogin';
import makeCancelable from '../helpers/PromiseWrapper';
import { getCsrfToken, handleCsrfFailure } from '../helpers/GetCsrfToken';

// export default class Login extends React.Component {
export default class Login extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      loginFailed: false,
      emailEmpty: false,
      emailValid: true,
      passwordEmpty: false,
      passwordVisible: false,
      emailAddress: "",
    };
    this.requests = [];
  }

  componentWillUnmount() {
    for (let i = 0; i < this.requests.length; i++) {
      this.requests[i].cancel();
    }
  }

  validateEmail(e) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@(([[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const emailInput = document.getElementById('emailAddress');

    if (e.target.value.trim().length === 0) {
      this.setState({
        emailValid: true,
        emailEmpty: false
      });
      emailInput.classList.add('warning');
    } else {
      if (re.test(e.target.value.trim())) {
        this.setState({
          emailValid: true,
          emailEmpty: false
        });
        emailInput.classList.remove('warning');
      } else {
        this.setState({
          emailValid: false,
          emailEmpty: false
        });
        emailInput.classList.add('warning');
      }
    }
  };

  handleKeyDown(e) {
    if (e.key === 'Enter') {
      this.handleLoginAsCustomer();
    }
  }

  handleLoginAsCustomer() {
    const emailAddress = document.getElementById('emailAddress').value;
    const password = document.getElementById('password').value;
    this.setState({
      loginFailed: false,
      emailEmpty: !emailAddress,
      passwordEmpty: !password
    });

    if (!!emailAddress && !!password) {
      this.setState({
        loading: true
      });
      let request = makeCancelable(fetch('api/Customer/Login', {
        method: 'post',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-XSRF-TOKEN': getCsrfToken()
        },
        body: JSON.stringify({
          emailAddress: emailAddress,
          password: password
        })
      }));
      this.requests.push(request);
      request.then(async response => {
        if (response.status === 400) {
          handleCsrfFailure();
          return
        }
        let data;
        try {
          data = await response.json()
            if (
                !!data.customerSessionToken &&
                data.customerSessionToken.pizzaExpressId > 0
            ) {
                this.setState({
                    loading: false
                });
                this.props.handleLogin(data);
            }
            else
                throw "Login Failed";
        } catch (error) {
          this.setState({
            loginFailed: true,
            loading: false
          });
        }
      })
    }
  }

  handleVisibility() {
    const pwInput = document.getElementById('password');
    if (pwInput.type === 'password') {
      pwInput.type = 'text';
      this.setState({ passwordVisible: true });
    } else {
      pwInput.type = 'password';
      this.setState({ passwordVisible: false });
    }
  }

  render() {
    const elementEye = <FontAwesomeIcon icon={faEye} />
    const elementEyeSlash = <FontAwesomeIcon icon={faEyeSlash} />

    return (
      <div className="login-form">
        <div className="login-form-inner">
          <div className="social-login">
            <FacebookLogin handleLogin={this.props.handleLogin.bind(this)} goToRegister={this.props.goToRegisterFromSocial} />
            <GoogleLogin handleLogin={this.props.handleLogin.bind(this)} goToRegister={this.props.goToRegisterFromSocial} />
          </div>

          <div className="login-form-input">
            <label>Email address</label>
            <input
              id="emailAddress"
              type="email"
              placeholder="customer@pizzaexpress.com"
              onKeyDown={e => this.handleKeyDown(e)}
              onBlur={e => this.validateEmail(e)}
              onChange={e => this.setState({ emailAddress: e.target.value })}
            />
            {this.state.emailEmpty && (
              <p className="warning">Email cannot be empty.</p>
            )}
            {!this.state.emailEmpty && !this.state.emailValid && (
              <p id="email-warning" className="warning">
                Email does not have a correct format.
              </p>
            )}
          </div>
          <div>
            <label>Password</label>
            <div className="password-input-wrapper">
              <input
                autoCapitalize="none"
                id="password"
                type="password"
                placeholder="Your password"
                onKeyDown={e => this.handleKeyDown(e)}
              />

              <button
                className="show-hide"
                id="pwShowHideBtn"
                onClick={() => this.handleVisibility()}
              >
                {!this.state.passwordVisible && <div>{elementEyeSlash}</div>}
                {this.state.passwordVisible && <div>{elementEye}</div>}
              </button>
            </div>
            {this.state.passwordEmpty && (
              <p className="warning">Password cannot be empty.</p>
            )}
          </div>
          <p className="forgotten-password">
            <a
              className="text-cta"
              onClick={() => this.props.goToForgottenPassword(this.state.emailAddress)}
            >
              Forgotten password?
            </a>
          </p>
          {this.state.loginFailed && (
            <p className="warning">
              Login failed, please try different credentials.
            </p>
          )}

          <button
            className={`btn btn-primary login-button ${this.state.loading === true && 'disabled'}`}
            onClick={() => this.handleLoginAsCustomer()}
          >
            {(this.state.loading === false) ? 'Log in with Email' : <span className="cta-dual-ring"></span>}
          </button>
        </div>
        <div className="sign-up-with-email">
          <button
            className={`btn btn-secondary sign-up`}
            onClick={() => this.props.signUp()}
          >
            Sign up
            </button>
        </div>
      </div>
    );
  }
}
